import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

export const Layout = () => {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1" data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
